import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc, collection, getDocs } from "firebase/firestore";
import { db } from "../firebase-config";

import SubcollectionSection from "../component/SubcollectionSection";

export default function UseCaseDetail() {
  const { useCaseId } = useParams();
  const [useCase, setUseCase] = useState(null);
  const [subcollections, setSubcollections] = useState({});
  // const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

useEffect(() => {
  async function loadData() {
    // Load main use case document
    const useCaseRef = doc(db, "useCases", useCaseId)
    const useCaseSnap = await getDoc(useCaseRef)
    if (useCaseSnap.exists()) {
      setUseCase(useCaseSnap.data())
    }

    // const objectsRef = collection(db, "useCases", useCaseId, "Objects");
    // const flowsRef = collection(db, "useCases", useCaseId, "Flows");
    // Collected below

    // Load subcollections
    const subNames = ["Objects", "Flows"];
    const results = {};

    for (const name of subNames) {
      const ref = collection(db, "useCases", useCaseId, name);
      const snap = await getDocs(ref);

      const items = {};
      snap.forEach(doc => {
        items[doc.id] = doc.data();
      })

      results[name] = items;
    }

    setSubcollections(results);
    setLoading(false);

    // const snap = await getDocs(objectsRef);
    // const [objectsSnap, flowsSnap] = await Promise.all([
    //   getDocs(objectsRef),
    //   getDocs(flowsRef)
    // ])

    // console.log("Snapshot empty?", snap.empty);
    // console.log("Document IDs:", snap.docs.map(d => d.id));

    // const results = {};

    // const objects = {};
    // objectsSnap.forEach(doc => {
    //   objects[doc.id] = doc.data();
    // });

    // const flows = {};
    // flowsSnap.forEach(doc => {
    //   flows[doc.id] = doc.data();
    // })

    // snap.docs.forEach(doc => {
    //   console.log("Doc data for", doc.id, doc.data());
    //   results[doc.id] = doc.data();   // ⭐ THIS IS THE KEY
    // });

    // setSubcollections({
    //   Objects: objects,
    //   Flows: flows
    // });
    
    // setLoading(false);
  }

  loadData();
}, [useCaseId]);

  if (loading) return <p>Loading...</p>;
  if (!useCase) return <p>Use Case cannot be found.</p>

  return (
    <div className="useCaseDetailContainer">
        <h1>{useCaseId}</h1> {/* Name of use case in Firebase */}

        {/* Objects */}
        <h2 className="sectionHeader">Objects</h2> {/*Subcollection*/}
        <div className="useCaseRows">
          {Object.entries(subcollections.Objects || {}).map(([subName, item]) => (
              <SubcollectionSection 
                key={subName}
                subName={subName}
                item={item}
                type="object"
                // key={subName}
                // id={subName}
                // data={data}
              />
          ))}
        </div>

        {/* Flows */}
        <h2 className="sectionHeader">Flows</h2>
        <div className="useCaseRows">
          {Object.entries(subcollections.Flows || {}).map(([flowName, flowItem]) => (
            // <a href={`/useCases/${useCaseId}/flows/${flowName}`}>
              <SubcollectionSection 
                key={flowName}
                subName={flowName}
                item={flowItem}
                type="flow"
                parentUseCaseId={useCaseId}
                // key={id}
                // id={id}
                // data={data}
                // key={`flow-${flowName}`}
              />
            // </a>
          ))}
        </div>
    </div>
  );
}
